/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * ---------------------------------------------------------------------------------------------
 */
import { createSlice } from '@reduxjs/toolkit';

import { getActionPayload } from '@tdp/core/persistStore';

export enum HeaderActionTypes {
  GetShellInfo = 'Header_GetShellInfo',
}

const shellInfo = getActionPayload(HeaderActionTypes.GetShellInfo);

export const headerSlice = createSlice({
  name: 'header',
  initialState: {
    headerData: (shellInfo ? JSON.parse(shellInfo) : {}) as unknown,
  },
  reducers: {
    updateShellHeaderInfo: (state, action) => {
      state.headerData = action.payload;
    },
  },
});
